import { ValidationResult } from './validationResult';

export class CommandResponse {
  HasValidationResults: boolean;
  Message: string;
  Payload: any;
  Succeeded: boolean
  ValidationResults: ValidationResult[];
  Warnings: string[];
}

export class CommandResponseTyped<T> extends CommandResponse {
  Payload: T;
}




// WEBPACK FOOTER //
// ./src/app/data/framework/commandResponse.ts